export function quantizeStep(step, resolution=16, shouldRound=true) {
    if (shouldRound) {
        return resolution * Math.round(step / resolution);
    } else {
        return resolution * Math.floor(step / resolution);
    }
}
